import { MutationFn } from 'react-apollo';
import {
  RequestTaxFormDownload,
  FetchTaxFormDownload,
} from '@reverbdotcom/commons/src/rql';

export const TAXES_HELP_CENTER_ARTICLE_ID = '4411577966227';
export const PREVIOUS_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID = '4411577966227';
export const UPCOMING_YEAR_TAX_REPORTING_REQUIREMENTS_ARTICLE_ID = '12763053152531';

export interface ITaxForm {
  id: string;
  taxFormType: string;
  taxYear: number;
  taxFormDownload: FetchTaxFormDownload._TaxFormDownload;
  lastRequestedAt: string;
}

export interface MutationProps {
  requestTaxFormDownload: MutationFn<RequestTaxFormDownload.Mutation, RequestTaxFormDownload.Variables>;
  fetchTaxFormDownload: MutationFn<FetchTaxFormDownload.Mutation, FetchTaxFormDownload.Variables>;
}
